var LayoutComponent = (function () {
    function LayoutComponent() {
    }
    LayoutComponent.prototype.ngOnInit = function () {
    };
    return LayoutComponent;
}());
export { LayoutComponent };



// WEBPACK FOOTER //
// /build/client-cms/src/app/layout/layout.component.ts.pre-build-optimizer.js